import api from '@/store/api/contract'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    contract: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        contract: state => state.contract
    },
    actions: {
        /**
         * @param {{contractId: number}} data
         * @returns {Promise<*>}
         */
        showContract: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showContract(data)
                commit(mutationTypes.SET_CONTRACT, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetContract: async ({commit}) => commit(mutationTypes.RESET_CONTRACT)
    },
    mutations: {
        [mutationTypes.SET_CONTRACT]: (state, data) => state.contract = data,
        [mutationTypes.RESET_CONTRACT]: (state) => Object.assign(state, initialState())
    }
}
